import { useGlobalState } from "../../services/hostelConst";
import React, { useState, useEffect, useCallback, useRef } from "react";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { Trash2 } from "lucide-react";
import FormBuilderPropertiesPanel from "./FormBuilderProperties";
import { useSelector, useDispatch } from "react-redux";
import FormBuilderNavbar from "./FormBuildernavBar";
import { getFormsDetails } from "../../services/Users-services"; 
import { useParams } from "react-router-dom";
import {
  addSection,
  updateStyling,
  addComponent,
  removeComponent,
  moveElements,
  removeSection,
  getElementById,
  loadExistingForm,
  moveSections,
  updateSectionTitle,
} from "../../services/redux/reducers/customFormBuildeSclice";
import { CustomTextTitle } from "./draggableFileds/TextTitle";
import { CustomMultiSelect } from "./draggableFileds/CustomMultiSelect";
import { CustomFileInput } from "./draggableFileds/CustomFileInput";
import { CustomTextInput } from "./draggableFileds/TextInputFields";
import { CustomNumberInput } from "./draggableFileds/CustomNumberInput";
import { CustomTextarea } from "./draggableFileds/CustomTextarea";
import { CustomCheckbox } from "./draggableFileds/CustomCheckbox";
import { CustomRadio } from "./draggableFileds/CustomRadio";
import { CustomSelect } from "./draggableFileds/CustomSelect";
import { CustomDivider } from "./draggableFileds/CustomDivider";
import { CustomTextBlock } from "./draggableFileds/CustomTextBlock";
import { CustomDatePicker } from "./draggableFileds/CustomDatePicker";
import { CustomTimePicker } from "./draggableFileds/CustomTimePicker";
import { CustomButton } from "./draggableFileds/CustomButton";
import { CustomImage } from "./draggableFileds/CustomImage";
import FormPreview from "./formPreview";
  const getElementColor = (color) => {
    switch (color) {
      case "primary":
        return "#3b82f6";
      case "success":
        return "#10b981";
      case "secondary":
        return "#6b7280";
      case "danger":
        return "#ef4444";
      case "warning":
        return "#f59e0b";
      case "info":
        return "#3b82f6";
      default:
        return "#3b82f6";
    }
  };

  const getElementColorLight = (color) => {
    switch (color) {
      case "primary":
        return "#dbeafe";
      case "success":
        return "#d1fae5";
      case "secondary":
        return "#f3f4f6";
      case "danger":
        return "#fee2e2";
      case "warning":
        return "#fef3c7";
      case "info":
        return "#dbeafe";
      default:
        return "#dbeafe";
    }
  };

  const getElementTypeColor = (type) => {
    switch (type) {
      case "input":
        return "#3b82f6";
      case "content":
        return "#8b5cf6";
      case "layout":
        return "#6b7280";
      default:
        return "#6b7280";
    }
  };
const FormsIndex = () => {
  const { triggerChildSidebar } = useGlobalState();
  triggerChildSidebar(false);
  return (
    <>
      <FormBuilderApp />
      <style jsx global>{`
        /* Rich Text Editor Styles */
        .rich-text-editor {
          border: 1px solid #ced4da;
          border-radius: 0.25rem;
          background: white;
        }

        .rich-text-editor-toolbar {
          display: flex;
          flex-wrap: wrap;
          gap: 4px;
          padding: 8px;
          background-color: #f8f9fa;
          border-bottom: 1px solid #dee2e6;
        }

        .rich-text-editor-toolbar button {
          padding: 4px 8px;
          border: 1px solid #ccc;
          border-radius: 3px;
          background: white;
          cursor: pointer;
          font-size: 12px;
        }

        .rich-text-editor-toolbar button:hover {
          background-color: #e9ecef;
        }

        .rich-text-editor-content {
          min-height: 150px;
          padding: 12px;
          outline: none;
        }

        .rich-text-editor-content ul,
        .rich-text-editor-content ol {
          margin: 0;
          padding-left: 20px;
        }

        .rich-text-editor-content p {
          margin: 0 0 8px 0;
        }

        .rich-text-editor-content a {
          color: #0066cc;
          text-decoration: underline;
        }
        .section-dragging {
          opacity: 0.5;
          transform: scale(1.02);
          transition: all 0.2s ease-in-out;
          box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
        }

        .section-drag-over {
          border-top: 3px solid #0d6efd;
        }

        .drag-handle:active {
          cursor: grabbing;
        }
        .draggable-element {
          background-color: #ffffff;
          transition: all 0.2s ease;
          border-left: 4px solid transparent;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
          margin-bottom: 8px;
          border-radius: 6px;
        }

        .draggable-element:hover {
          background-color: #f0f4ff;
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
        }

        .form-section {
          background-color: #f0f4f8;
          min-height: 120px;
          border-radius: 8px;
          margin-bottom: 20px;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
        }

        .form-section.drag-over {
          border: 2px #0d6efd;
          background-color: rgba(13, 110, 253, 0.08);
        }

        .element-instance {
          background-color: white;
          cursor: grab;
          transition: transform 0.2s ease, opacity 0.2s ease;
          border-radius: 6px;
          position: relative;
          margin: 0; /* Changed from 0.5rem to 0 */
          border: 1px solid #dee2e6;
          padding: 0.75rem;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          width: 100%; /* Ensure element fills its wrapper */
        }

        .element-instance.dragging {
          opacity: 0.6;
          transform: scale(0.95);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
          z-index: 1000;
        }

        .element-instance.ghost {
          opacity: 0.3;
          transform: scale(0.9);
        }

        /* Styles for drag and drop interaction */
        .element-instance.drag-over-top {
          border-top: 3px solid #0d6efd;
        }

        .element-instance.drag-over-bottom {
          border-bottom: 3px solid #0d6efd;
        }

        .element-instance.drag-over-left {
          border-left: 3px solid #0d6efd;
        }

        .element-instance.drag-over-right {
          border-right: 3px solid #0d6efd;
        }

        .position-indicator {
          position: absolute;
          background-color: #0d6efd;
          transition: all 0.2s ease;
          z-index: 100;
          animation: pulse 0.5s infinite alternate;
        }

        .form-row-container {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          width: 100%;
          min-height: 60px;
          align-items: flex-start;
          padding: 8px;
          background-color: rgba(255, 255, 255, 0.6);
          border-radius: 4px;
          margin-top: 10px;
          overflow-x: auto;
          scrollbar-width: thin;
          scrollbar-color: #ccc transparent;
          gap: 8px;
        }

        /* Updated styles for element wrapper */

        .element-wrapper {
          transition: flex 0.3s ease, width 0.3s ease;
          min-width: 150px;
          flex-shrink: 0;
        }

        .element-wrapper.full-width {
          flex: 1 1 0;
          min-width: 0;
        }

        .element-wrapper.fixed-width {
          flex: 0 0 auto;
        }

        /* Hide scrollbar when not hovering */
        .form-row-container:not(:hover) {
          scrollbar-width: none;
          -ms-overflow-style: none;
        }

        .form-row-container:not(:hover)::-webkit-scrollbar {
          display: none;
        }

        /* Show scrollbar on hover */
        .form-row-container:hover {
          scrollbar-width: thin;
          -ms-overflow-style: auto;
        }

        .form-row-container:hover::-webkit-scrollbar {
          display: block;
          height: 6px;
        }

        .form-row-container::-webkit-scrollbar-track {
          background: transparent;
        }

        .form-row-container::-webkit-scrollbar-thumb {
          background-color: #ccc;
          border-radius: 3px;
        }

        .form-row-container::-webkit-scrollbar-thumb:hover {
          background-color: #999;
        }

        @keyframes pulse {
          0% {
            opacity: 0.5;
            transform: scale(1);
          }
          50% {
            opacity: 1;
            transform: scale(1.02);
          }
          100% {
            opacity: 0.5;
            transform: scale(1);
          }
        }

        .drop-indicator {
          height: 4px;
          background: #0d6efd;
          border-radius: 2px;
          margin: 2px 0;
          animation: pulse 1s infinite;
        }

        /* Enhanced styles for better drag visualization */
        .can-drop {
          background-color: rgba(13, 110, 253, 0.05);
          box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.5);
        }

        .editable-field {
          cursor: text;
          padding: 0.25rem 0.5rem;
          border-radius: 0.25rem;
          transition: background-color 0.2s ease;
        }

        .editable-field:hover {
          background-color: rgba(0, 0, 0, 0.05);
        }

        .editable-field:hover .bi-pencil {
          opacity: 1;
        }

        .editable-field .bi-pencil {
          opacity: 0.5;
          transition: opacity 0.2s ease;
        }
      `}</style>
    </>
  );
};

// Main App Component
const FormBuilderApp = ({}) => {
  // State for form elements
  const { id } = useParams(); // Get form ID from URL
  const [isEditing, setIsEditing] = useState(false);
  const [formDetails, setFormDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [formElements, setFormElements] = useState([
    {
      id: "text-title",
      name: "Text Title",
      icon: "text-title",
      type: "input",
      color: "primary",
    },
    {
      id: "multiSelect",
      name: "Multi-Select",
      icon: "list-check",
      type: "input",
      color: "primary",
    },
    {
      id: "file-input",
      name: "File Upload",
      icon: "file-earmark-arrow-up",
      type: "input",
      color: "success",
    },
    {
      id: "text-input",
      name: "Text Input",
      icon: "input-cursor-text",
      type: "input",
      color: "primary",
    },
    {
      id: "number-input",
      name: "Number Input",
      icon: "123",
      type: "input",
      color: "primary",
    },
    {
      id: "textarea",
      name: "Text Area",
      icon: "textarea-t",
      type: "input",
      color: "primary",
    },
    {
      id: "checkbox",
      name: "Checkbox",
      icon: "check-square",
      type: "input",
      color: "success",
    },
    {
      id: "radio",
      name: "Radio Button",
      icon: "record-circle",
      type: "input",
      color: "success",
    },
    {
      id: "select",
      name: "Select Dropdown",
      icon: "menu-button-wide",
      type: "input",
      color: "primary",
    },
    {
      id: "divider",
      name: "Divider",
      icon: "hr",
      type: "layout",
      color: "secondary",
    },

    {
      id: "text",
      name: "Text Block",
      icon: "text-paragraph",
      type: "content",
      color: "info",
    },
    {
      id: "date",
      name: "Date Picker",
      icon: "calendar-date",
      type: "input",
      color: "warning",
    },
    {
      id: "time",
      name: "Time Picker",
      icon: "clock",
      type: "input",
      color: "warning",
    },
    {
      id: "button",
      name: "Button",
      icon: "ui-radios",
      type: "input",
      color: "danger",
    },
  ]);
  useEffect(() => {
    const loadFormData = async () => {
      if (id) {
        setLoading(true);
        setIsEditing(true);

        try {
          const response = await getFormsDetails(id);

          if (response.status === "success") {
            const formData = response.data;
            setFormDetails(formData);

            // Load the form structure into Redux
            dispatch(
              loadExistingForm({
                metadata: formData._METADATA_,
              })
            );

            console.log("Form loaded successfully:", formData);
          } else {
            console.error("Failed to load form:", response);
            // Handle error - maybe redirect or show error message
          }
        } catch (error) {
          console.error("Error loading form:", error);
          // Handle error
        } finally {
          setLoading(false);
        }
      }
    };

    loadFormData();
  }, [id, dispatch]);

  const customFormBuilder = useSelector((state) => state.customFormBuilder);
  console.log("customFormBuilder", JSON.stringify(customFormBuilder));
  // State for filtered elements
  const [filteredElements, setFilteredElements] = useState(formElements);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeFilter, setActiveFilter] = useState("all");

  // State for canvas customFormBuilder
  // const [setSections] = useState([
  //   { id: "section-1", elements: [], title: "Section 1" },
  // ]);

  // State for selected element
  const [selectedElement, setSelectedElement] = useState(null);
  const moveSectionPosition = (sourceIndex, targetIndex) => {
    dispatch(
      moveSections({
        sourceIndex,
        targetIndex,
      })
    );
  };
  // Filter elements based on search term and active filter
  useEffect(() => {
    let filtered = formElements;

    // Apply search filter
    if (searchTerm) {
      filtered = filtered.filter((element) =>
        element.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Apply type filter
    if (activeFilter !== "all") {
      filtered = filtered.filter((element) => element.type === activeFilter);
    }

    setFilteredElements(filtered);
  }, [searchTerm, activeFilter, formElements]);

  // Function to add a new section
  const _addSection = () => {
    const newSectionId = `section-${customFormBuilder.length + 1}`;
    const instanceId = `section-${customFormBuilder.length + 1}-${Date.now()}`;
    dispatch(
      addSection({
        id: "section",
        instanceId,
        elements: [],

        title: `Section ${customFormBuilder.length + 1}`,
      })
    );
    // setSections([
    //   ...customFormBuilder,
    //   {
    //     id: newSectionId,
    //     instanceId,
    //     type: "section",
    //     elements: [],
    //     title: `Section ${customFormBuilder.length + 1}`,
    //   },
    // ]);
    setSelectedElement(customFormBuilder[customFormBuilder.length - 1]);
  };

  const handleDrop = (item, sectionIndex) => {
    // sectionIndex is now directly passed as a number

    if (sectionIndex < 0 || sectionIndex >= customFormBuilder.length) {
      console.error(`Invalid section index: ${sectionIndex}`);
      return;
    }

    if (item.source === "sidebar") {
      const elementToDrop = formElements.find((el) => el.id === item.id);
      if (!elementToDrop) {
        console.error(`Element with id ${item.id} not found`);
        return;
      }

      const newElement = {
        ...elementToDrop,
        instanceId: `${elementToDrop.id}-${Date.now()}`,
      };

      dispatch(
        addComponent({
          index: sectionIndex,
          data: newElement,
        })
      );

      setSelectedElement(newElement);
    } else if (item.source === "canvas") {
      const fromSectionIndex = item.sectionIndex;

      if (
        fromSectionIndex < 0 ||
        fromSectionIndex >= customFormBuilder.length
      ) {
        console.error(`Invalid source section index: ${fromSectionIndex}`);
        return;
      }

      let dropIndex = item.dropIndex;
      if (dropIndex === undefined) {
        dropIndex = customFormBuilder[sectionIndex].elements?.length || 0;
      }

      dispatch(
        moveElements({
          formSection: fromSectionIndex,
          toSection: sectionIndex,
          fromIndex: item.index,
          toIndex: dropIndex,
        })
      );
    }
  };
  {
    // Add these functions to your component:
  }

  // Function to move elements within or between customFormBuilder
  const moveElement = (fromSectionId, toSectionId, fromIndex, toIndex) => {
    dispatch(
      moveElements({
        formSection: customFormBuilder.findIndex(
          (section) => section.id === fromSectionId
        ),
        toSection: customFormBuilder.findIndex(
          (section) => section.id === toSectionId
        ),
        fromIndex,
        toIndex,
      })
    );
    // setSections((prevSections) => {
    //   const newSections = [...prevSections];

    //   // Find the source and destination customFormBuilder
    //   const fromSectionIdx = newSections.findIndex(
    //     (s) => s.id === fromSectionId
    //   );
    //   const toSectionIdx = newSections.findIndex((s) => s.id === toSectionId);

    //   if (fromSectionIdx === -1 || toSectionIdx === -1) return prevSections;

    //   // Get the element being moved
    //   const movedElement = {
    //     ...newSections[fromSectionIdx].elements[fromIndex],
    //   };

    //   // Remove from source
    //   newSections[fromSectionIdx].elements.splice(fromIndex, 1);

    //   // Add to destination
    //   newSections[toSectionIdx].elements.splice(toIndex, 0, movedElement);

    //   return newSections;
    // });
  };

  // Function to select an element for editing
  const selectElement = (element) => {
    console.log("Selected element:", element);
    setSelectedElement(element);
  };

  // Function to delete an element
  // Function to delete an element
  // Function to delete an element
  const deleteElement = (sectionIndex, elementInstanceId) => {
    console.log("deleteElement called with:", {
      sectionIndex,
      elementInstanceId,
    });

    // Ensure sectionIndex is a number
    const index =
      typeof sectionIndex === "string" ? parseInt(sectionIndex) : sectionIndex;

    if (isNaN(index) || index < 0 || index >= customFormBuilder.length) {
      console.error(`Invalid section index: ${sectionIndex}`);
      return;
    }

    const section = customFormBuilder[index];
    console.log("Section found:", section);

    if (!section || !section.elements) {
      console.error(`Section ${index} does not have elements array`);
      return;
    }

    const elementIndex = section.elements.findIndex(
      (el) => el.instanceId === elementInstanceId
    );

    if (elementIndex === -1) {
      console.error(`Element with instanceId ${elementInstanceId} not found`);
      return;
    }

    dispatch(
      removeComponent({
        index: index,
        fieldIndex: elementIndex,
      })
    );

    if (selectedElement?.instanceId === elementInstanceId) {
      setSelectedElement(null);
    }
  };
  // Function to delete a section
  // Function to delete a section
// Function to delete a section

const deleteSection = (sectionIndex) => {
  // Use sectionIndex directly instead of finding by sectionId
  if (sectionIndex < 0 || sectionIndex >= customFormBuilder.length) {
    console.error(`Invalid section index for removal: ${sectionIndex}`);
    return;
  }

  dispatch(
    removeSection({
      index: sectionIndex, // Pass the index directly
    })
  );

  // Clear selected element if it was in the deleted section
  if (selectedElement) {
    const sectionOfSelectedElement = customFormBuilder.find((section) =>
      section.elements.some(
        (el) => el.instanceId === selectedElement.instanceId
      )
    );

    if (
      sectionOfSelectedElement &&
      customFormBuilder.indexOf(sectionOfSelectedElement) === sectionIndex
    ) {
      setSelectedElement(null);
    }
  }
};
  const setSelectedElementToForm = (e) => {
    if (e.currentTarget === e.target) {
      e.stopPropagation();
      setSelectedElement({
        id: "form",
        type: "form",
        instanceId: "form",
        title: "Form",
      });
    }
  };
  // Add this function to your component
  const getElementIcon = (elementId) => {
    switch (elementId) {
      case "text-title":
        return <i className="bi bi-type-h1"></i>;
      case "text-input":
        return <i className="bi bi-input-cursor-text"></i>;
      case "number-input":
        return <i className="bi bi-123"></i>;
      case "textarea":
        return <i className="bi bi-textarea-t"></i>;
      case "checkbox":
        return <i className="bi bi-check-square"></i>;
      case "radio":
        return <i className="bi bi-record-circle"></i>;
      case "select":
        return <i className="bi bi-menu-button-wide"></i>;
      case "multiSelect":
        return <i className="bi bi-list-check"></i>;
      case "file-input":
        return <i className="bi bi-file-earmark-arrow-up"></i>;
      case "divider":
        return <i className="bi bi-hr"></i>;
      case "text":
        return <i className="bi bi-text-paragraph"></i>;
      case "date":
        return <i className="bi bi-calendar-date"></i>;
      case "time":
        return <i className="bi bi-clock"></i>;
      case "button":
        return <i className="bi bi-ui-radios"></i>;
      case "image":
        return <i className="bi bi-image"></i>;
      default:
        return <i className="bi bi-question-circle"></i>;
    }
  };

  // Function to update section title
  const updateSectionTitle = (sectionId, newTitle) => {
    dispatch(
      updateSectionTitle({
        index: customFormBuilder.findIndex(
          (section) => section.id === sectionId
        ),
        title: newTitle,
      })
    );
    // setSections((prevSections) =>
    //   prevSections.map((section) => {
    //     if (section.id === sectionId) {
    //       return {
    //         ...section,
    //         title: newTitle,
    //       };
    //     }
    //     return section;
    //   })
    // );
  };
  const [showPreview, setShowPreview] = useState(false);
  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <p className="mt-2">Loading form...</p>
        </div>
      </div>
    );
  }

  return (
    <DndProvider backend={HTML5Backend}>
      <div
        className="d-flex p-0 m-0 w-100"
        style={{
          overflow: "hidden",
          height: "99vh", // Adjust based on your navbar height (60px) and any margins
          flexDirection: "column",
        }}
      >
        <div className="w-100">
          <FormBuilderNavbar
            showPreview={showPreview}
            formId={id}
            isEditing={isEditing}
            formTitle={formDetails?.NAME || ""}
            formDescription={formDetails?.DESCRIPTION || ""}
            setShowPreview={setShowPreview}
          />
        </div>

        {showPreview ? (
          <FormPreview formBuilder={customFormBuilder} />
        ) : (
          <div
            className="d-flex w-100 h-100"
            style={{
              overflow: "hidden",
              height: "100%", // Changed from 100vh to 100%
            }}
          >
            {/* Left Sidebar - Form Elements */}
            <div
              className="bg-white border-end shadow-sm ms-0 d-flex flex-column"
              style={{
                maxWidth: "12.67%",
                overflowX: "hidden",
                backgroundColor: "#f8fafc",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
                borderRadius: "0 0 0 8px",
              }}
            >
              <div className="p-3 d-flex flex-column h-100">
                <div className="sidebar-header">
                  <h5 className="mb-3 fw-bold text-primary d-flex align-items-center">
                    <i className="bi bi-grid-3x3-gap me-2"></i>
                    Elements
                  </h5>

                  {/* Search bar */}
                  <div className="search-container position-relative mb-3">
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Search elements..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      style={{
                        borderRadius: "6px",
                        padding: "0.4rem 0.75rem 0.4rem 2rem",
                        fontSize: "0.75rem",
                        border: "1px solid #e2e8f0",
                        boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                      }}
                    />
                    <i
                      className="bi bi-search position-absolute"
                      style={{
                        left: "0.75rem",
                        top: "50%",
                        transform: "translateY(-50%)",
                        fontSize: "0.7rem",
                        opacity: "0.6",
                      }}
                    ></i>
                  </div>
                </div>

                {/* Elements list with scrolling */}
                <div className="elements-list flex-grow-1 overflow-auto">
                  <div className="d-flex flex-column align-items-center gap-2">
                    {filteredElements.map((element) => (
                      <div
                        key={element.id}
                        className="w-100 element-card"
                        style={{
                          maxWidth: "100%",
                          minWidth: 0,
                        }}
                      >
                        <DraggableElement element={element} />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <style jsx>{`
              .elements-list::-webkit-scrollbar {
                width: 4px;
              }

              .elements-list::-webkit-scrollbar-track {
                background: #f1f1f1;
                border-radius: 4px;
              }

              .elements-list::-webkit-scrollbar-thumb {
                background: #cbd5e0;
                border-radius: 4px;
              }

              .elements-list::-webkit-scrollbar-thumb:hover {
                background: #a0aec0;
              }

              .element-card:hover .draggable-element {
                transform: translateY(-2px);
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
              }
            `}</style>

            {/* Center - Canvas */}
            <div
              className="bg-light p-2  overflow-auto"
              style={{
                flex: "0 0 66.67%",
                maxWidth: "66.67%",
              }}
            >
              <div
                className=" p-2 pb-0 bg-white "
                onClick={setSelectedElementToForm}
                style={{
                  border:
                    selectedElement?.instanceId === "form"
                      ? "2px solid #0d6efd"
                      : "",
                  borderRadius: "15px",
                }}
              >
                <div
                  className="canvas-controls mb-4 d-flex justify-content-between align-items-center"
                  onClick={setSelectedElementToForm}
                >
                  <h4 className="m-0">Form Builder</h4>
                  <div>
                    <button
                      className="btn btn-primary btn-sm"
                      onClick={_addSection}
                    >
                      <i className="bi bi-plus-circle me-1"></i> Add Section
                    </button>
                  </div>
                </div>

                <div className="bg-white canvas-area p-2">
                  {customFormBuilder.map((section, index) => (
                    <DraggableFormSection
                      key={section.instanceId} // Use instanceId instead of id for better tracking
                      section={section}
                      sectionIndex={index}
                      onDrop={handleDrop}
                      onSelectElement={selectElement}
                      onDeleteElement={deleteElement}
                      onDeleteSection={deleteSection}
                      onUpdateTitle={updateSectionTitle}
                      selectedElement={selectedElement}
                      moveSectionPosition={moveSectionPosition}
                    />
                  ))}
                  {customFormBuilder.length === 0 && (
                    <div className="text-center p-5 bg-white rounded border">
                      <i className="bi bi-layout-text-window-reverse fs-1 text-muted"></i>
                      <h5 className="mt-3">Start Building Your Form</h5>
                      <p className="text-muted">
                        Click the "Add Section" button to create your first
                        section
                      </p>
                      <button className="btn btn-primary" onClick={_addSection}>
                        <i className="bi bi-plus-circle me-1"></i> Add Section
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Right Sidebar - Settings */}
            <div
              className="bg-white border-start overflow-auto shadow-sm"
              style={{
                flex: "0 0 21.67%",
                maxWidth: "21.67%",

                borderRadius: "0 0 15px 0",
              }}
            >
              <div className="p-0">
                <div className="sidebar-header">
                  {/* <h5
                  className="mb-3"
                  style={{
                    textAlign: "center",
                  }}
                >
                  Properties
                </h5> */}
                </div>

                {selectedElement ? (
                  <FormBuilderPropertiesPanel element={selectedElement} />
                ) : (
                  <div className="settings-placeholder text-center p-4">
                    <i className="bi bi-gear fs-1 text-muted"></i>
                    <p className="text-muted mt-3">
                      Select an element to view and edit its properties
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </DndProvider>
  );
};

const getTypeIcon = (type) => {
  switch (type) {
    case "input":
      return "input-cursor";
    case "layout":
      return "grid-1x2";
    case "content":
      return "card-text";
    default:
      return "question-circle";
  }
};

const DraggableElement = ({ element }) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: "FORM_ELEMENT",
    item: { id: element.id, type: element.type, source: "sidebar" },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  return (
    <div
      ref={drag}
      className={`draggable-element p-1 rounded border d-flex align-items-center justify-content-between ${
        isDragging ? "opacity-50" : ""
      }`}
      style={{
        cursor: "move",
        transition: "all 0.2s ease",
        backgroundColor: "#ffffff",
        boxShadow: "0 1px 2px rgba(0, 0, 0, 0.03)",
        borderColor: "#e5e7eb",
        borderRadius: "6px",
        borderLeft: `3px solid ${getElementColor(element.color)}`,
      }}
    >
      <div className="d-flex align-items-center">
        <div
          className="element-icon-container me-1 d-flex align-items-center justify-content-center"
          style={{
            width: "22px",
            height: "22px",
            borderRadius: "4px",
            backgroundColor: `${getElementColorLight(element.color)}`,
            color: `${getElementColor(element.color)}`,
          }}
        >
          <i
            className={`bi bi-${element.icon || "question-circle"}`}
            style={{ fontSize: "0.8rem" }}
          ></i>
        </div>
        <span style={{ fontSize: "0.7rem", fontWeight: "500" }}>
          {element.name}
        </span>
      </div>
      <div
        className="drag-handle ms-1"
        style={{ fontSize: "0.6rem", color: "#94a3b8" }}
      >
        <i className="bi bi-grip-vertical"></i>
      </div>
    </div>
  );
};

// Fix for the DraggableElementInstance component

const DraggableElementInstance = ({
  element,
  index,
  onSelectElement,
  onDeleteElement,
  sectionIndex,
  sectionId,
  isSelected,
  moveElement,
}) => {
  const ref = React.useRef(null);
  const [{ isDragging }, drag] = useDrag({
    type: "CANVAS_ELEMENT",
    item: () => {
      onSelectElement(element);
      return {
        instanceId: element.instanceId,
        index,
        sectionIndex, // Changed from sectionId
        source: "canvas",
      };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [{ isOver }, drop] = useDrop({
    accept: ["CANVAS_ELEMENT", "FORM_ELEMENT"],
    hover: (item, monitor) => {
      if (!ref.current) return;

      const dragIndex = item.index;
      const hoverIndex = index;
      const dragSectionIndex = item.sectionIndex;
      const hoverSectionIndex = sectionIndex;

      // Don't replace items with themselves
      if (
        item.source === "canvas" &&
        dragIndex === hoverIndex &&
        dragSectionIndex === hoverSectionIndex
      ) {
        return;
      }

      // For items from sidebar, let the section handle it
      if (item.source === "sidebar") {
        return;
      }

      // Determine rectangle on screen
      const hoverBoundingRect = ref.current.getBoundingClientRect();
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      // Only perform the move when the mouse has crossed half of the items height
      if (dragSectionIndex === hoverSectionIndex) {
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
          return;
        }
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
          return;
        }
      }

      // Move the item
      moveElement(dragSectionIndex, hoverSectionIndex, dragIndex, hoverIndex);

      // Update the item for correct continuous dragging
      item.index = hoverIndex;
      item.sectionIndex = hoverSectionIndex;
    },
    collect: (monitor) => ({
      isOver: monitor.isOver({ shallow: true }),
    }),
  });

  drag(drop(ref));

  return (
    <div
      ref={ref}
      className={`element-instance ${element.type}-type ${
        isSelected ? "selected" : ""
      } ${isDragging ? "dragging" : ""} ${isOver ? "drag-over" : ""}`}
      onClick={() => onSelectElement(element)}
      style={{
        width: "100%",
        cursor: isDragging ? "grabbing" : "grab",
        opacity: isDragging ? 0.6 : 1,
        border: isSelected ? "2px solid #0d6efd" : "1px solid #dee2e6",
        position: "relative",
      }}
    >
      {renderSimpleFieldPreview(element)}
      <div className="field-controls d-flex justify-content-end align-items-end position-absolute top-0 end-0 p-2 pe-0 me-0">
        <button
          className="btn btn-sm"
          onClick={(e) => {
            e.stopPropagation();
            onDeleteElement(sectionIndex, element.instanceId);
          }}
        >
          <Trash2 size={15} />
        </button>
      </div>
    </div>
  );
};

export const ElementTransition = ({ children, id }) => {
  const elementRef = useRef(null);
  const positionRef = useRef(null);

  useEffect(() => {
    if (!elementRef.current) return;

    // Store the current position
    const currentPos = elementRef.current.getBoundingClientRect();

    // If we have a previous position, calculate the difference and animate
    if (positionRef.current) {
      const previousPos = positionRef.current;
      const deltaX = previousPos.left - currentPos.left;
      const deltaY = previousPos.top - currentPos.top;

      if (deltaX || deltaY) {
        // Apply the FLIP animation technique
        // First: set the inverse transform to make it appear in the old position
        elementRef.current.style.transform = `translate(${deltaX}px, ${deltaY}px)`;
        elementRef.current.style.transition = "none";

        // Force a reflow to apply the inverse transform
        // elementRef.current.offsetHeight;

        // Last: animate to the new position
        elementRef.current.style.transform = "";
        elementRef.current.style.transition = "transform 0.3s ease";
      }
    }

    // Update the position reference for next time
    positionRef.current = currentPos;

    // Clean up the transition after it's done
    const cleanup = () => {
      if (elementRef.current) {
        elementRef.current.style.transition = "";
      }
    };

    const timer = setTimeout(cleanup, 300);
    return () => clearTimeout(timer);
  }, [id, children]);

  return (
    <div ref={elementRef} style={{ willChange: "transform" }}>
      {children}
    </div>
  );
};
// Fix for the FormSection component

const FormSection = ({
  section,
  sectionIndex,
  onDrop,
  onSelectElement,

  onDeleteElement,
  onDeleteSection,
  onUpdateTitle,
  selectedElement,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [sectionTitle, setSectionTitle] = useState(section.title);
  const [isDraggingOver, setIsDraggingOver] = useState(false);
  const titleInputRef = useRef(null);
  const sectionRef = useRef(null);
  const [{ isOver, canDrop }, dropRef] = useDrop({
    accept: ["FORM_ELEMENT", "CANVAS_ELEMENT"],
    drop: (item, monitor) => {
      if (monitor.didDrop()) {
        return;
      }

      if (item.source === "sidebar") {
        // Use sectionIndex instead of section.id
        onDrop(item, sectionIndex);
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver({ shallow: true }),
      canDrop: monitor.canDrop(),
    }),
  });
  // Handle leaving the drop target
  useEffect(() => {
    if (!isOver && isDraggingOver) {
      setIsDraggingOver(false);

      // Clean up any indicators
      if (sectionRef.current) {
        const dropIndicator = sectionRef.current.querySelector(
          ".section-drop-indicator"
        );
        if (dropIndicator) {
          dropIndicator.remove();
        }
      }
    }
  }, [isOver, isDraggingOver]);

  // Use the moveElement callback to handle internal element movements
    const moveElement = useCallback(
      (fromSectionIndex, toSectionIndex, fromIndex, toIndex) => {
        onDrop(
          {
            source: "canvas",
            sectionIndex: fromSectionIndex, // Changed from sectionId
            index: fromIndex,
            dropIndex: toIndex,
          },
          toSectionIndex // Pass index instead of id
        );
      },
      [onDrop]
    );

  // Handle section title changes
  const handleTitleChange = () => {
    if (sectionTitle.trim()) {
      onUpdateTitle(section.id, sectionTitle.trim());
      setIsEditing(false);
    }
  };

  const handleTitleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleTitleChange();
    } else if (e.key === "Escape") {
      setSectionTitle(section.title);
      setIsEditing(false);
    }
  };

  useEffect(() => {
    if (isEditing && titleInputRef.current) {
      titleInputRef.current.focus();
      titleInputRef.current.select();
    }
  }, [isEditing]);

  // Select section when clicking on the section container
  const handleSectionClick = (e) => {
    if (e.currentTarget === e.target) {
      e.stopPropagation();
      onSelectElement({
        ...section,
        type: "section",
      });
    }
  };

  // Combine refs
  const combineRefs = (...refs) => {
    return (node) => {
      refs.forEach((ref) => {
        if (typeof ref === "function") {
          ref(node);
        } else if (ref != null) {
          ref.current = node;
        }
      });
    };
  };

  return (
    <div
      ref={combineRefs(dropRef, sectionRef)}
      className={`form-section position-relative mb-4 rounded-lg shadow-sm ${
        isOver && canDrop ? "drag-over" : ""
      }`}
      onClick={handleSectionClick}
      style={{
        border:
          selectedElement?.instanceId === section?.instanceId
            ? "2px solid #0d6efd"
            : "1px solid #A8A7A7FF",
        transition: "all 0.2s ease-in-out",
        transform: isOver && canDrop ? "scale(1.01)" : "scale(1)",
      }}
    >
      {/* Section Header */}
      <div
        className="section-header d-flex justify-content-between align-items-center p-3 rounded-top"
        style={{
          backgroundColor: "#f8f9fa",
          borderBottom: "1px solid #e0e0e0",
          cursor: "move",
        }}
        onClick={handleSectionClick}
      >
        <div className="d-flex align-items-center">
          <i
            className="bi bi-grip-vertical text-muted me-2"
            style={{
              fontSize: "1.2rem",
              cursor: "grab",
            }}
          ></i>
          {isEditing ? (
            <input
              ref={titleInputRef}
              type="text"
              className="form-control form-control-sm me-2"
              value={sectionTitle}
              onChange={(e) => setSectionTitle(e.target.value)}
              onBlur={handleTitleChange}
              onKeyDown={handleTitleKeyDown}
              style={{
                backgroundColor: "white",
                border: "1px solid #4a90e2",
              }}
            />
          ) : (
            <div
              className="d-flex align-items-center"
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                e.stopPropagation(); // Prevent section selection
                setIsEditing(true);
              }}
            >
              <h6
                className="m-0 me-2 section-title"
                style={{
                  color: "#333",
                  fontWeight: 600,
                }}
              >
                {section.title}
              </h6>
              <i
                className="bi bi-pencil text-muted"
                style={{
                  fontSize: "0.8rem",
                  opacity: 0.6,
                }}
              ></i>
            </div>
          )}
        </div>

        <div className="section-actions">
          <button
            className="btn btn-sm me-2"
            onClick={(e) => {
              e.stopPropagation(); // Prevent section selection
              onDeleteSection(); // Pass sectionIndex instead of section.id
            }}
            title="Remove Section"
            style={{
              color: "#f44336",
              padding: "0.25rem 0.5rem",
              transition: "all 0.2s ease",
            }}
          >
            <Trash2 size={20} />
          </button>
        </div>
      </div>

      {/* Section Content */}
      <div
        className="section-content p-3"
        onClick={(e) => {
          if (e.currentTarget === e.target) {
            e.stopPropagation();
            onSelectElement(section);
          }
        }}
      >
        {section.elements && section.elements.length > 0 ? (
          <div
            className="form-row-container rounded"
            style={{
              backgroundColor: "#f8f9fa",
              border: "1px solid #A8A7A7FF",
              padding: "0.75rem",
              position: "relative",
              minHeight: "120px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {section.elements.map((element, index) => (
              <div
                className={`element-wrapper ${
                  element.style?.width === "100%" ? "full-width" : "fixed-width"
                }`}
                key={element.instanceId}
                onClick={(e) => e.stopPropagation()}
                style={{
                  width:
                    element.style?.width === "100%"
                      ? "auto"
                      : element.style?.width,
                }}
              >
                <ElementTransition id={element.instanceId}>
                  <DraggableElementInstance
                    element={element}
                    index={index}
                    onSelectElement={onSelectElement}
                    onDeleteElement={onDeleteElement}
                    sectionIndex={sectionIndex} // Pass index instead of id
                    isSelected={
                      selectedElement?.instanceId === element.instanceId
                    }
                    moveElement={moveElement}
                  />
                </ElementTransition>
              </div>
            ))}
          </div>
        ) : (
          <div
            className="empty-section text-center w-100 py-4 rounded"
            style={{
              border: "2px dashed #e0e0e0",
              backgroundColor:
                isOver && canDrop ? "rgba(13, 110, 253, 0.05)" : "white",
              transition: "all 0.2s ease",
            }}
          >
            <i
              className="bi bi-arrow-down-square mb-2"
              style={{
                color: "#1B6FCEFF",
                fontSize: "2rem",
              }}
            ></i>
            <p className="mb-0 small" style={{ color: "#6c757d" }}>
              Drag and drop form elements here
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
// Add this new component after the FormSection component
const DraggableFormSection = ({
  section,
  sectionIndex,
  onDrop,
  onSelectElement,
  onDeleteElement,
  onDeleteSection,
  onUpdateTitle,
  selectedElement,
  moveSectionPosition,
}) => {
  const sectionRef = useRef(null);

  const [{ isDragging }, drag] = useDrag({
    type: "SECTION",
    item: () => {
      return {
        id: section.id,
        instanceId: section.instanceId,
        sourceIndex: sectionIndex,
        type: "SECTION",
      };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [{ isOver, canDrop }, drop] = useDrop({
    accept: "SECTION",
    hover: (item, monitor) => {
      if (!sectionRef.current) return;

      const dragIndex = item.sourceIndex;
      const hoverIndex = sectionIndex;

      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }

      // Determine rectangle on screen
      const hoverBoundingRect = sectionRef.current?.getBoundingClientRect();

      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

      // Determine mouse position
      const clientOffset = monitor.getClientOffset();

      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%

      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }

      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }

      // Time to actually perform the action
      moveSectionPosition(dragIndex, hoverIndex);

      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.sourceIndex = hoverIndex;
    },
    collect: (monitor) => ({
      isOver: monitor.isOver({ shallow: true }),
      canDrop: monitor.canDrop(),
    }),
  });

  // Combine drag and drop refs
  const attachRef = (el) => {
    drag(el);
    drop(el);
    sectionRef.current = el;
  };

  return (
    <div
      ref={attachRef}
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: "move",
        transform: isDragging ? "scale(1.02)" : "scale(1)",
        transition: "transform 0.2s ease-in-out",
        position: "relative",
      }}
    >
      {isOver && canDrop && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            height: "2px",
            right: 0,
            background: "#0d6efd",
            zIndex: 1000,
          }}
        />
      )}
      <FormSection
        section={section}
        sectionIndex={sectionIndex}
        onDrop={onDrop}
        onSelectElement={onSelectElement}
        onDeleteElement={onDeleteElement}
        onDeleteSection={() => onDeleteSection(sectionIndex)} // Always pass current index
        onUpdateTitle={onUpdateTitle}
        selectedElement={selectedElement}
      />
    </div>
  );
};

// Function to render a simplified preview of the element (just field and label)
const renderSimpleFieldPreview = (element) => {
  switch (element.id) {
    case "text-title":
      return <CustomTextTitle instanceId={element.instanceId} />;

    case "text-input":
      return <CustomTextInput instanceId={element.instanceId} />;

    case "number-input":
      return <CustomNumberInput instanceId={element.instanceId} />;

    case "textarea":
      return <CustomTextarea instanceId={element.instanceId} />;

    case "checkbox":
      return <CustomCheckbox instanceId={element.instanceId} />;

    case "radio":
      return <CustomRadio instanceId={element.instanceId} />;

    case "select":
      return <CustomSelect instanceId={element.instanceId} />;

    case "multiSelect":
      return <CustomMultiSelect instanceId={element.instanceId} />; // Add this line

    case "file-input":
      return <CustomFileInput instanceId={element.instanceId} />; // Add this line

    case "divider":
      return <CustomDivider instanceId={element.instanceId} />;

    case "text":
      return <CustomTextBlock instanceId={element.instanceId} />;

    case "date":
      return <CustomDatePicker instanceId={element.instanceId} />;

    case "time":
      return <CustomTimePicker instanceId={element.instanceId} />;

    case "button":
      return <CustomButton instanceId={element.instanceId} />;

    case "image":
      return <CustomImage instanceId={element.instanceId} />;

    default:
      return (
        <div className="field-content">
          <label className="field-label form-label">Unknown Field</label>
          <input
            type="text"
            className="form-control form-control-sm border"
            disabled
            placeholder="Unknown field type"
          />
        </div>
      );
  }
};

const EditableField = ({ value, placeholder, onChange, className }) => {
  const [isEditing, setIsEditing] = useState(false);
  const inputRef = useRef(null);

  const handleDoubleClick = () => {
    setIsEditing(true);
  };

  const handleBlur = () => {
    setIsEditing(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleBlur();
    }
  };

  useEffect(() => {
    if (isEditing) {
      inputRef.current?.focus();
      inputRef.current?.select();
    }
  }, [isEditing]);

  if (isEditing) {
    return (
      <input
        ref={inputRef}
        type="text"
        className={`form-control form-control-sm ${className}`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
      />
    );
  }

  return (
    <div
      className={`editable-field d-flex align-items-center ${className}`}
      onDoubleClick={handleDoubleClick}
    >
      <span className="me-2">{value || placeholder}</span>
      <i
        className="bi bi-pencil text-muted"
        style={{ cursor: "pointer", fontSize: "0.75rem" }}
        onClick={handleDoubleClick}
      ></i>
    </div>
  );
};



export default FormsIndex;
